import { createFileRoute, redirect } from '@tanstack/react-router'
import { BillFormScreen } from '@/features/accounting-bills/bill-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for editing a DRAFT bill — the counterpart of
 * `invoices.$invoiceId.edit`.
 *
 * The API refuses a PATCH on anything but a draft, so this guard only keeps a
 * user without `accounting_bill.edit` out of a screen they cannot use; the
 * route itself is reachable for a confirmed bill and the form renders its
 * loaded values without a save that would succeed.
 */
export const Route = createFileRoute('/_authenticated/accounting/bills/$billId/edit')({
  beforeLoad: ({ context, params }) => {
    if (!hasGrant(context.queryClient, 'accounting_bill.edit')) {
      throw redirect({
        to: '/accounting/bills/$billId',
        params: { billId: params.billId },
      })
    }
  },
  component: AccountingBillEditRoute,
})

function AccountingBillEditRoute() {
  const { billId } = Route.useParams()

  return <BillFormScreen billId={billId} />
}
